export default "__VITE_ASSET__DR2RGxM5__"